import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
@Component({
  selector: 'jsg-jsc-confirm-action-view',
  templateUrl: './jsc-confirm-action-view.component.html',
  styleUrls: ['./jsc-confirm-action-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JscConfirmActionViewComponent {
  @Input() actionNumber: string;
  @Input() styleOfCause: string;
  @Input() judicialCenter: string;
  @Input() areaOfLaw: string;

  constructor() {}
}
